/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  ApplySpaceTemplate,
  ComputedContentSourceDocument,
  ComputedContentSourceRevision,
  EntityId,
  JSONDocument,
  List,
  Revision,
  RevisionFile,
  RevisionPage,
  RevisionPageDocument,
  RevisionPageGroup,
  RevisionPageMetaLinks,
  RevisionReusableContent,
  RevisionSemanticChanges,
  SearchPageResult,
  URL,
} from "./data-contracts";

/**
 * @description Searches the full text of all published pages in a space and returns matching pages with ranked excerpts. Use this to find pages by topic or keyword within a specific space. For site-wide search across all spaces in a site, use the site search endpoint instead.
 * @tags space-content
 * @name SearchSpaceContent
 * @summary Full-text search across all pages in a space
 * @request GET:/spaces/{spaceId}/search
 * @secure
 */

// @ts-ignore
export const searchSpaceContent: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {
    /** @maxLength 512 */
    query: string;
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SearchPageResult[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/search",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Retrieves the live published revision of a space, which includes the full page tree structure and associated files. Use this to inspect the currently published content state of a space. For in-progress edits, use the change-request content endpoint instead.
 * @tags space-content
 * @name GetCurrentRevision
 * @summary Get the current published content revision of a space
 * @request GET:/spaces/{spaceId}/content
 * @secure
 */

// @ts-ignore
export const getCurrentRevision: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Revision;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/content",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Populates a space with pages and structure from a specified template, bootstrapping it with a standard documentation layout. Use this to initialise a new space rather than creating pages manually. Optionally apply the template to a specific change request instead of main content by providing the changeRequestId field.
 * @tags space-content
 * @name ApplyTemplateToSpace
 * @summary Apply a content template to populate a space with initial pages
 * @request POST:/spaces/{spaceId}/content/template
 * @secure
 */

// @ts-ignore
export const applyTemplateToSpace: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {};
  RequestBody: ApplySpaceTemplate & {
    /** The ID of the change request to apply the template to. If not provided, the template is applied to the main content. */
    changeRequestId?: string;
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 201;
} = {
  route: "/spaces/{spaceId}/content/template",
  method: "post",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns the complete list of all pages in a space's current revision, including their titles, URL paths, and parent-child relationships. Use this to understand the full content structure of a space or build navigation. For the content of a single page, use getPageById or getPageByPath instead.
 * @tags space-content
 * @name ListPages
 * @summary List all pages in a space with their hierarchy and metadata
 * @request GET:/spaces/{spaceId}/content/pages
 * @secure
 */

// @ts-ignore
export const listPages: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    pages: RevisionPage[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/content/pages",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns a paginated list of all files (images, attachments, and other assets) uploaded to a space's current revision. Use this to discover available assets or audit file usage across a space.
 * @tags space-content
 * @name ListFiles
 * @summary List all uploaded files and assets in a space
 * @request GET:/spaces/{spaceId}/content/files
 * @secure
 */

// @ts-ignore
export const listFiles: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: RevisionFile[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/content/files",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Retrieves metadata and download URL for a single file (image, attachment, or other asset) in a space's current revision by its file ID. Use this when you have a specific file ID and need its URL, MIME type, or other metadata.
 * @tags space-content
 * @name GetFileById
 * @summary Get a specific uploaded file from a space by its ID
 * @request GET:/spaces/{spaceId}/content/files/{fileId}
 * @secure
 */

// @ts-ignore
export const getFileById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique id of the file */
    fileId: EntityId;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionFile;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/content/files/{fileId}",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Retrieves a page's metadata, content, and document structure from a space's current revision by its page ID. Use this when you know the exact page ID and need its content or path. For lookup by URL path, use the content/path endpoint instead.
 * @tags space-content
 * @name GetPageById
 * @summary Get a single page from a space by its ID
 * @request GET:/spaces/{spaceId}/content/page/{pageId}
 * @secure
 */

// @ts-ignore
export const getPageById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique id of the page */
    pageId: EntityId;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
    /**
     * Controls how content references are formatted in markdown output. Ignored unless `format=markdown`.
     *
     * - `relative`: Format page references as relative links from the current page. Other references might not be handled.
     * - `stable`: Format content references as stable idempotent refs containing their identifiers.
     * @default "relative"
     */
    "format.markdown.refs"?: "relative" | "stable";
    /**
     * Controls whether the document should be evaluated.
     * - When set to `true`, the entire document will be evaluated.
     * - When set to `deterministic-only`, only expressions that depend
     *   exclusively on deterministic inputs will be evaluated.
     * @default false
     */
    evaluated?: boolean | "deterministic-only";
    /**
     * Controls whether references to other content are resolved and expanded.
     * - When set to `false`, references are preserved, including reusable content includes in Markdown.
     * - When set to `true`, all supported content references are expanded.
     * - When set to `reusable-contents`, only reusable content references are expanded.
     * When omitted, Markdown responses expand all supported content references, while document responses preserve them.
     */
    dereferenced?: boolean | "reusable-contents";
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionPage;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/content/page/{pageId}",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns structural navigation metadata for a page, including references to the previous page, next page, and parent page within the space's hierarchy. Use this to implement or inspect linear navigation flows in a docs site without fetching the full page tree.
 * @tags space-content
 * @name ListSpacePageMetaLinks
 * @summary Get navigation metadata links for a page (previous, next, parent)
 * @request GET:/spaces/{spaceId}/content/page/{pageId}/meta-links
 * @secure
 */

// @ts-ignore
export const listSpacePageMetaLinks: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique id of the page */
    pageId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionPageMetaLinks;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/content/page/{pageId}/meta-links",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Retrieves a page by its URL path (e.g. /guides/getting-started) from the space's current revision. Use this when you have a page's path rather than its ID. Returns either a document page or a group/section page depending on the path.
 * @tags space-content
 * @name GetPageByPath
 * @summary Get a page from a space by its URL path
 * @request GET:/spaces/{spaceId}/content/path/{pagePath}
 * @secure
 */

// @ts-ignore
export const getPageByPath: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The path of the page in the revision. */
    pagePath: string;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
    /**
     * Controls how content references are formatted in markdown output. Ignored unless `format=markdown`.
     *
     * - `relative`: Format page references as relative links from the current page. Other references might not be handled.
     * - `stable`: Format content references as stable idempotent refs containing their identifiers.
     * @default "relative"
     */
    "format.markdown.refs"?: "relative" | "stable";
    /**
     * Controls whether the document should be evaluated.
     * - When set to `true`, the entire document will be evaluated.
     * - When set to `deterministic-only`, only expressions that depend
     *   exclusively on deterministic inputs will be evaluated.
     * @default false
     */
    evaluated?: boolean | "deterministic-only";
    /**
     * Controls whether references to other content are resolved and expanded.
     * - When set to `false`, references are preserved, including reusable content includes in Markdown.
     * - When set to `true`, all supported content references are expanded.
     * - When set to `reusable-contents`, only reusable content references are expanded.
     * When omitted, Markdown responses expand all supported content references, while document responses preserve them.
     */
    dereferenced?: boolean | "reusable-contents";
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `true` is passed, mutable Git metadata may be served from a cache.
     * @default false
     */
    cachedMetadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionPageDocument | RevisionPageGroup;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/content/path/{pagePath}",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Retrieves a reusable content block (a shared snippet that can be embedded across multiple pages) from a space's current revision by its ID. Use this to read the content of a reusable block when you have its ID.
 * @tags space-content
 * @name GetReusableContentById
 * @summary Get a reusable content block from a space by its ID
 * @request GET:/spaces/{spaceId}/content/reusable-contents/{reusableContentId}
 * @secure
 */

// @ts-ignore
export const getReusableContentById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique id of the reusable content */
    reusableContentId: EntityId;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionReusableContent;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/content/reusable-contents/{reusableContentId}",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Server-renders a document from a provided content source definition, evaluating template expressions and resolving variables to produce a fully computed document. Use this to preview how dynamic content will look without publishing a full revision.
 * @tags space-content
 * @name GetComputedDocument
 * @summary Compute and render a document from a structured content source
 * @request POST:/spaces/{spaceId}/content/computed/document
 * @secure
 */

// @ts-ignore
export const getComputedDocument: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {
    /** Version of the schema used for the document. */
    schema?: "current" | "next";
  };
  RequestBody: {
    source: ComputedContentSourceDocument;
    /** Seed to use for the generation of IDs. */
    seed: string;
  };
  RequestHeaders: {};
  ResponseBody: JSONDocument;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/content/computed/document",
  method: "post",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Server-renders an entire revision — pages, files, and reusable contents — from a provided content source definition, resolving all template expressions and variables. Use this to evaluate and preview computed content before publishing. Returns the full set of pages and files with all dynamic content fully resolved.
 * @tags space-content
 * @name GetComputedRevision
 * @summary Compute and render a full revision from a structured content source
 * @request POST:/spaces/{spaceId}/content/computed/revision
 * @secure
 */

// @ts-ignore
export const getComputedRevision: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    source: ComputedContentSourceRevision;
    /** Seed to use for the generation of IDs. */
    seed: string;
  };
  RequestHeaders: {};
  ResponseBody: {
    pages: RevisionPage[];
    files: RevisionFile[];
    reusableContents: RevisionReusableContent[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/content/computed/revision",
  method: "post",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns the structured JSON document for a specific document ID within a space. Documents are the low-level block-based representation of page content. Use this when you have a documentId and need the raw block structure. To retrieve a page's document by pageId, use the page document endpoint instead.
 * @tags space-content
 * @name GetDocumentById
 * @summary Get a raw document from a space by its document ID
 * @request GET:/spaces/{spaceId}/documents/{documentId}
 * @secure
 */

// @ts-ignore
export const getDocumentById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** ID of the document in the space */
    documentId: string;
  };
  RequestQuery: {
    /** Version of the schema used for the document. */
    schema?: "current" | "next";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: JSONDocument;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/documents/{documentId}",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns a specific revision snapshot of a space by its revision ID, including the page tree structure and revision metadata. Use this to inspect a historical state of a space. To access the current live content, use the space content endpoint instead.
 * @tags space-content
 * @name GetRevisionById
 * @summary Get a specific historical revision of a space
 * @request GET:/spaces/{spaceId}/revisions/{revisionId}
 * @secure
 */

// @ts-ignore
export const getRevisionById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique id of the revision */
    revisionId: EntityId;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Revision;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/revisions/{revisionId}",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns a structured diff of the semantic changes introduced by a revision compared to its parent revision, such as added, removed, or updated pages and blocks. Use this to understand what changed in a specific revision.
 * @tags space-content
 * @name GetRevisionSemanticChanges
 * @summary Get semantic content changes introduced by a revision
 * @request GET:/spaces/{spaceId}/revisions/{revisionId}/changes
 * @secure
 */

// @ts-ignore
export const getRevisionSemanticChanges: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique id of the revision */
    revisionId: EntityId;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
    /**
     * Limit the number of changes returned
     * @default 10
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionSemanticChanges;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/revisions/{revisionId}/changes",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns the full flat list of all pages (document pages and group pages) in a specific historical revision of a space. Use this to inspect the complete page tree of a past snapshot. For the current live content pages, use the space content pages endpoint.
 * @tags space-content
 * @name ListPagesInRevisionById
 * @summary List all pages in a specific historical revision of a space
 * @request GET:/spaces/{spaceId}/revisions/{revisionId}/pages
 * @secure
 */

// @ts-ignore
export const listPagesInRevisionById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique id of the revision */
    revisionId: EntityId;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    pages: RevisionPage[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/revisions/{revisionId}/pages",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns a paginated list of files (images and other binary assets) attached to a specific revision of a space. Use this to enumerate all media assets present in a historical snapshot. To get a single file, use the revision file by ID endpoint.
 * @tags space-content
 * @name ListFilesInRevisionById
 * @summary List all files (images, assets) in a specific space revision
 * @request GET:/spaces/{spaceId}/revisions/{revisionId}/files
 * @secure
 */

// @ts-ignore
export const listFilesInRevisionById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique id of the revision */
    revisionId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: RevisionFile[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/revisions/{revisionId}/files",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns the metadata for a single file (image or binary asset) within a specific revision of a space. Use this to retrieve download URL, MIME type, and dimensions for a known file ID. To list all files in a revision, use the revision files list endpoint.
 * @tags space-content
 * @name GetFileInRevisionById
 * @summary Get a specific file from a space revision by its file ID
 * @request GET:/spaces/{spaceId}/revisions/{revisionId}/files/{fileId}
 * @secure
 */

// @ts-ignore
export const getFileInRevisionById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique id of the revision */
    revisionId: EntityId;
    /** The unique id of the file */
    fileId: EntityId;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionFile;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/revisions/{revisionId}/files/{fileId}",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns the full page object (metadata and optionally document content) for a specific page within a historical revision. Use documentFormat to control whether content is returned as blocks or markdown. To get a page from the current live revision, use the space content page endpoint.
 * @tags space-content
 * @name GetPageInRevisionById
 * @summary Get a page from a specific historical revision by its page ID
 * @request GET:/spaces/{spaceId}/revisions/{revisionId}/page/{pageId}
 * @secure
 */

// @ts-ignore
export const getPageInRevisionById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique id of the revision */
    revisionId: EntityId;
    /** The unique id of the page */
    pageId: EntityId;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
    /**
     * Controls how content references are formatted in markdown output. Ignored unless `format=markdown`.
     *
     * - `relative`: Format page references as relative links from the current page. Other references might not be handled.
     * - `stable`: Format content references as stable idempotent refs containing their identifiers.
     * @default "relative"
     */
    "format.markdown.refs"?: "relative" | "stable";
    /**
     * Controls whether the document should be evaluated.
     * - When set to `true`, the entire document will be evaluated.
     * - When set to `deterministic-only`, only expressions that depend
     *   exclusively on deterministic inputs will be evaluated.
     * @default false
     */
    evaluated?: boolean | "deterministic-only";
    /**
     * Controls whether references to other content are resolved and expanded.
     * - When set to `false`, references are preserved, including reusable content includes in Markdown.
     * - When set to `true`, all supported content references are expanded.
     * - When set to `reusable-contents`, only reusable content references are expanded.
     * When omitted, Markdown responses expand all supported content references, while document responses preserve them.
     */
    dereferenced?: boolean | "reusable-contents";
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionPage;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/revisions/{revisionId}/page/{pageId}",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns the structured JSON document (block tree) for a specific page within a historical revision of a space. Use this when you need the low-level block representation of historical page content. For the current live content, use the space content page document endpoint.
 * @tags space-content
 * @name GetPageDocumentInRevisionById
 * @summary Get the raw document body of a page in a historical revision
 * @request GET:/spaces/{spaceId}/revisions/{revisionId}/page/{pageId}/document
 * @secure
 */

// @ts-ignore
export const getPageDocumentInRevisionById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique id of the revision */
    revisionId: EntityId;
    /** The unique id of the page */
    pageId: EntityId;
  };
  RequestQuery: {
    /**
     * Controls whether the document should be evaluated.
     * - When set to `true`, the entire document will be evaluated.
     * - When set to `deterministic-only`, only expressions that depend
     *   exclusively on deterministic inputs will be evaluated.
     * @default false
     */
    evaluated?: boolean | "deterministic-only";
    /**
     * Controls whether references to other content are resolved and expanded.
     * - When set to `false`, references are preserved, including reusable content includes in Markdown.
     * - When set to `true`, all supported content references are expanded.
     * - When set to `reusable-contents`, only reusable content references are expanded.
     * When omitted, Markdown responses expand all supported content references, while document responses preserve them.
     */
    dereferenced?: boolean | "reusable-contents";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: JSONDocument;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/revisions/{revisionId}/page/{pageId}/document",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns a page from a historical revision looked up by its URL path (e.g. "getting-started/installation") rather than its ID. Useful when you know the page path but not the ID. Use documentFormat to control whether content is returned as blocks or markdown. For the current live revision, use the content path endpoint.
 * @tags space-content
 * @name GetPageInRevisionByPath
 * @summary Get a page from a specific historical revision by its URL path
 * @request GET:/spaces/{spaceId}/revisions/{revisionId}/path/{pagePath}
 * @secure
 */

// @ts-ignore
export const getPageInRevisionByPath: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique id of the revision */
    revisionId: EntityId;
    /** The path of the page in the revision. */
    pagePath: string;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
    /**
     * Controls how content references are formatted in markdown output. Ignored unless `format=markdown`.
     *
     * - `relative`: Format page references as relative links from the current page. Other references might not be handled.
     * - `stable`: Format content references as stable idempotent refs containing their identifiers.
     * @default "relative"
     */
    "format.markdown.refs"?: "relative" | "stable";
    /**
     * Controls whether the document should be evaluated.
     * - When set to `true`, the entire document will be evaluated.
     * - When set to `deterministic-only`, only expressions that depend
     *   exclusively on deterministic inputs will be evaluated.
     * @default false
     */
    evaluated?: boolean | "deterministic-only";
    /**
     * Controls whether references to other content are resolved and expanded.
     * - When set to `false`, references are preserved, including reusable content includes in Markdown.
     * - When set to `true`, all supported content references are expanded.
     * - When set to `reusable-contents`, only reusable content references are expanded.
     * When omitted, Markdown responses expand all supported content references, while document responses preserve them.
     */
    dereferenced?: boolean | "reusable-contents";
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `true` is passed, mutable Git metadata may be served from a cache.
     * @default false
     */
    cachedMetadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionPageDocument | RevisionPageGroup;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/revisions/{revisionId}/path/{pagePath}",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns the meta navigation links for a specific page within a historical revision, including the previous and next page in the space's reading order. Use this to implement sequential navigation across historical content or to build a reading flow for a specific revision.
 * @tags space-content
 * @name ListRevisionPageMetaLinks
 * @summary List all meta links (prev/next navigation) for a page in a revision
 * @request GET:/spaces/{spaceId}/revisions/{revisionId}/page/{pageId}/meta-links
 * @secure
 */

// @ts-ignore
export const listRevisionPageMetaLinks: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: {
      mode: "partial";
      data: readonly ["getPublishedContentRevisionMetaLinks"];
      rollout: { edge: 10; shadow: 23 };
    };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique id of the revision */
    revisionId: EntityId;
    /** The unique id of the page */
    pageId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionPageMetaLinks;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/revisions/{revisionId}/page/{pageId}/meta-links",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: {
      mode: "partial",
      data: ["getPublishedContentRevisionMetaLinks"],
      rollout: { edge: 10, shadow: 23 },
    },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns metadata for a specific reusable content block within a historical revision of a space. Reusable content blocks are shared content snippets referenced across multiple pages. To get the actual document body of the reusable content, use the reusable content document endpoint.
 * @tags space-content
 * @name GetReusableContentInRevisionById
 * @summary Get a reusable content block from a historical revision by its ID
 * @request GET:/spaces/{spaceId}/revisions/{revisionId}/reusable-contents/{reusableContentId}
 * @secure
 */

// @ts-ignore
export const getReusableContentInRevisionById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique id of the revision */
    revisionId: EntityId;
    /** The unique id of the reusable content */
    reusableContentId: EntityId;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionReusableContent;
  ResponseStatusCode: 200;
} = {
  route:
    "/spaces/{spaceId}/revisions/{revisionId}/reusable-contents/{reusableContentId}",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns the structured JSON document (block tree) for a reusable content block within a specific historical revision of a space. Use this to read the actual content of a shared snippet at a point in time. For the metadata, use the reusable content by ID endpoint.
 * @tags space-content
 * @name GetReusableContentDocumentInRevisionById
 * @summary Get the document body of a reusable content block in a historical revision
 * @request GET:/spaces/{spaceId}/revisions/{revisionId}/reusable-contents/{reusableContentId}/document
 * @secure
 */

// @ts-ignore
export const getReusableContentDocumentInRevisionById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique id of the revision */
    revisionId: EntityId;
    /** The unique id of the reusable content */
    reusableContentId: EntityId;
  };
  RequestQuery: {
    /**
     * Controls whether the document should be evaluated.
     * - When set to `true`, the entire document will be evaluated.
     * - When set to `deterministic-only`, only expressions that depend
     *   exclusively on deterministic inputs will be evaluated.
     * @default false
     */
    evaluated?: boolean | "deterministic-only";
    /**
     * Controls whether references to other content are resolved and expanded.
     * - When set to `false`, references are preserved, including reusable content includes in Markdown.
     * - When set to `true`, all supported content references are expanded.
     * - When set to `reusable-contents`, only reusable content references are expanded.
     * When omitted, Markdown responses expand all supported content references, while document responses preserve them.
     */
    dereferenced?: boolean | "reusable-contents";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: JSONDocument;
  ResponseStatusCode: 200;
} = {
  route:
    "/spaces/{spaceId}/revisions/{revisionId}/reusable-contents/{reusableContentId}/document",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns a short-lived URL (valid for 1 hour) to download the space's content as a PDF file.
 * @tags space-content
 * @name GetSpacePdf
 * @summary Get a temporary URL to download a space or page as PDF
 * @request GET:/spaces/{spaceId}/pdf
 * @secure
 */

// @ts-ignore
export const getSpacePDF: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {
    /** Generate a PDF only for the provided page. */
    only?: boolean;
    /** ID of a specific page to generate a PDF for. */
    page?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    /** Temporary URL to print the content. The URL will work for 1h. */
    url: URL;
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/pdf",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
